<template>
    <div class="parking-option">
        <topNav :title="title"></topNav>
        <div style="margin: 0 auto;width: 30px;margin-top: 20px;" v-show="datas.length == 0 && !noData">
            <van-loading type="spinner" color="black"/>
        </div>
        
        <div class="no" v-show="noData">没有查询到相应套餐</div>
        <div class="parking-container">
            <ul>
                <li v-for="(item,index) in datas" :key="index" @click="changeParking(item)">
                    <div class="content">
                        <p>
                            {{item.parkingname}}
                        </p>
                    </div>
                    <div class="carnum">{{item.vehicleno}}</div>
                </li>
                <!-- <li v-for="(item,index) in datas" :key="index" @click="changeParking(item)">
                    <div class="car-icon"><b></b></div>
                    <div class="content">
                        <h2>{{item.parkingname}}</h2>
                        <p>车位：
                            <span v-for="(key,index2) in item.spaces" :key="index2">{{index2+1}}</span>
                        </p>
                    </div>
                    <div class="carnum">{{item.vehicleno}}</div>
                </li> -->
            </ul>
        </div>
    </div>
</template>
<script>
import topNav from "../topnav/topnav";
import commonService from '@/assets/commonService'
import { Loading } from 'vant';
export default {
    name:"parkingOption",//
    data(){
        return{
            msg:"",
            title:"选择车场",
            datas:[],
            carNum:"",
            noData:false,//没有查到相关信息
        }
    },
    created(){
        this.carNum = this.$route.query.carNum;
        commonService.getParkingList(this.carNum);//获取套餐详情
    },
    mounted(){

    },
    methods:{
        changeParking(data){
            this.$router.push({
                name:"recharge",
                params:{
                    carNum:this.carNum
                }
            });
            sessionStorage.setItem("carNum",this.carNum)
            sessionStorage.setItem("parkingno",data.parkingno)
            sessionStorage.setItem("id",data.commid)
            sessionStorage.setItem("commname",data.commname)
            sessionStorage.setItem("parkingname",data.parkingname)
        }
    },
    watch:{
        "$store.state.dataObj"(value){
            if(value){
                if(value.length>0){
                    this.datas = value;
                }else{
                    this.noData = true;
                    this.$dialog.alert({
                        title: '提示',
                        message: value.msg
                    })
                }
            }
        }
    },
    components:{
        topNav,
        [Loading.name]:Loading
    }
}
</script>
<style scoped>
.parking-option{
    background: #fff;
}
.parking-option .no{
    text-align: center;
    color: #999;
    line-height: 40px;
    font-size: 16px;
}
.parking-option .parking-container{

}
.parking-option .parking-container li{
    height: 42px;
    color: #999;
    text-align: left;
    font-size: 14px;
    padding: 15px 0;


    background: url("../../../static/images/option_bg.png");
    background-size: 100% 100%;
    color: #fff;
    width: 90%;
    margin: 0 auto;
    margin-top: 11px;
}
.parking-option .parking-container li .car-icon{
    float: left;
    border: 1px solid transparent;
}
.parking-option .parking-container li .car-icon b{
    background: url("../../../static/images/icon_car_1.png");
    width: 42px;
    height: 42px;
    background-size: 42px;
    display: block;
    margin-right: 10px;
    margin-left: 15px;
}
.parking-option .parking-container li .content{
    float: left;
}
.parking-option .parking-container li .content h2{
    color: #4687f8;
    padding-top: 5px;
}
.parking-option .parking-container li .content p{
    width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-top: 5px;
    font-size: 13px;
    text-indent: 23px;
    line-height: 27px;
}
@media screen and (max-width: 374px) {
    .parking-option .parking-container li .content p{
        width: 160px;
    }
}
.parking-option .parking-container li .carnum{
    float: right;
    border: 1px solid #fff;
    border-radius: 3px;
    padding: 1px 3px;
    margin-top: 10px;
    margin-right: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/recharge/parkingOption.vue